import axios from "../../utils/axios";
import AuthResponse from "../../interfaces/user";

export const login = async (username: string, password: string, captchaToken?: string) => {
  const payload = {
    username,
    password,
  };

  if (captchaToken) {
    const headers = { "x-recaptcha-token": captchaToken };
    return await axios.post("/auth/login", payload, headers);
  } else {
    return await axios.post("/auth/login", payload);
  }
};

export const refreshToken = async (refresh_token: string) => {
  const response = await axios.get(`/auth/token`, {
    Authorization: `Bearer ${refresh_token}`,
  });

  return response.data as AuthResponse;
};

export const loginWithAuthtoken = async (token: string) => {
  const response = await axios.post(`/auth/login`, {
    auth_token: token,
  });

  return response.data as AuthResponse;
};
